import React, { Component } from "react";
import { connect } from 'react-redux';
import axios from "axios";
import Topbar from '../components/Topbar';
import Sidebar from "../components/Sidebar";
import Loading from '../../../admin/components/Loading';
import { MDBDataTable } from "mdbreact";
import { CSVLink } from "react-csv";

class TokenDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			toggled: false,
			loading: true
		};
	}

	componentDidMount() {
		if (!this.props.location.state || !this.props.client.token_report) {
			this.props.history.push("/client");
		} else {
			axios
				.post("/api/admin/report/token/detail", this.props.location.state, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
				.then(res => {
					this.setState({
						...this.state,
						data: res.data,
						loading: false
					});
				})
				.catch(err => this.props.history.push("/distributor"));
		}
	}

	handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

	render() {
		let tableData = {
			columns: [
				{
					label: "User Name",
					field: "name",
					sort: "asc"
				},
				{
					label: "Phone Number",
					field: "number",
					sort: "asc"
				},
				{
					label: "Email Address",
					field: "email",
					sort: "asc"
				},
				{
					label: "Member ID",
					field: "memberId",
					sort: "asc"
				},
				{
					label: "e-Token Spent",
					field: "tokenSpent",
					sort: "asc"
				},
				{
					label: "Machine Type",
					field: "machineType",
					sort: "asc"
				},
				{
					label: "Transaction ID",
					field: "transactionId",
					sort: "asc"
				},
				{
					label: "Transaction Date",
					field: "date",
					sort: "asc"
				}
			],
			rows: this.state.data
		};

		let csv = [];

		if (this.state.data) {
			for (let i = 0; i < this.state.data.length; i++) {
				let data = {
					name: this.state.data[i].name,
					number: `=""${this.state.data[i].number}""`,
					email: this.state.data[i].email,
					memberId: this.state.data[i].memberId,
					tokenSpent: this.state.data[i].tokenSpent,
					machineType: this.state.data[i].machineType,
					transactionId: this.state.data[i].transactionId,
					date: this.state.data[i].date
				}
				csv.push(data);
			}
		}

		const csvData = {
			headers: [
				{ label: "User Name", key: "name" },
				{ label: "Phone Number", key: "number" },
				{ label: "Email Address", key: "email" },
				{ label: "Member ID", key: "memberId" },
				{ label: "e-Token Spent", key: "tokenSpent" },
				{ label: "Machine Type", key: "machineType" },
				{ label: "Transaction ID", key: "transactionId" },
				{ label: "Transaction Date", key: "date" }
			],
			data: csv
		};

		return (
			<div className="admin-page-container">
				<Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
				<div className="admin-page">
					<Topbar handleToggle={this.handleToggle} />
					<div className="admin-content">
						<div className="card">
							<div className="card-header">
								<h5 className="card-title">e-Token Detailed Report ({this.props.location.state ? this.props.location.state.outletName : ""})</h5>
							</div>

							<div className="card-body">
								{this.state.loading ? (
									<Loading />
								) : (
									<div>
										<MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
										<div className="d-grid gap-2 d-md-flex justify-content-md-end">
											<CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename="e-TokenDetailedReport.csv" target="_blank">
												Download Report
											</CSVLink>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
        client: state.client.client,
        token: state.client.token
	};
};

export default connect(mapStateToProps, null)(TokenDetail);
